import { GearPage } from "../components/GearPage";
import { HEROES, CORPORATE_GEAR, WEDDING_AV_PACKAGE, WEDDING_AUDIO_LIGHTS_PACKAGE } from "../data/gear";

const FEATURE_PACKAGES = [WEDDING_AV_PACKAGE, WEDDING_AUDIO_LIGHTS_PACKAGE];

export default function CorporateAV({ onQuote }) {
  return (
    <GearPage
      testid="corporate-av-page"
      hero={HEROES.corporate}
      eyebrow="AV Packages for Weddings"
      title="AV packages for weddings, beautifully run"
      intro="Complete audio and video packages plus individual gear for waterfront weddings, ceremonies and receptions along the Emerald Coast."
      banner="✓ Professional setup & teardown included on every booking"
      featurePackages={FEATURE_PACKAGES}
      gear={CORPORATE_GEAR}
      onQuote={onQuote}
    />
  );
}
